/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Content_Tree_SubtitleInputs */

const en_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 trees just for Plus users.`)
};

const ar_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 أشجار فقط لمستخدمي بلس.`)
};

const de_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Bäume nur für Plus-Nutzer.`)
};

const es_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 árboles solo para usuarios Plus.`)
};

const fr_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 arbres réservés aux utilisateurs Plus.`)
};

const it_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 alberi solo per gli utenti Plus.`)
};

const ja_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusユーザー限定の5種類の樹種`)
};

const ko_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 사용자 전용 나무 5종.`)
};

const pt_br_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 árvores somente para os usuários Plus.`)
};

const ru_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 деревьев только для пользователей Plus.`)
};

const th_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้ 5 ต้นสำหรับผู้ใช้ Plus เท่านั้น`)
};

const tr_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca Plus üyelerine özel 5 ağaç.`)
};

const zh_cn_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专属于 Plus 用户的 5 棵树种`)
};

const zh_tw_subscription_exclusive_content_tree_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Tree_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專屬於 Plus 用戶的 5 棵樹種`)
};

/**
* | output |
* | --- |
* | "5 trees just for Plus users." |
*
* @param {Subscription_Exclusive_Content_Tree_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_content_tree_subtitle = /** @type {((inputs?: Subscription_Exclusive_Content_Tree_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Content_Tree_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_content_tree_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_content_tree_subtitle(inputs)
	return zh_tw_subscription_exclusive_content_tree_subtitle(inputs)
});